import { getListingsById } from '../../ducks/marketplaceData.duck';

/**
 * Shared mapStateToProps factory for cleaning pages.
 * Each page (CleaningPage, CleaningCityPage, CleaningTorontoServicePage)
 * stores its own listing query result under a dedicated state slice — pass
 * that slice name here to get a consistent
 * { listings, queryInProgress, queryListingsError } prop shape.
 */
export const createCleaningMapStateToProps = stateSliceName => state => {
  const slice = state[stateSliceName] || {};
  const {
    currentPageResultIds = [],
    queryInProgress = false,
    queryListingsError = null,
  } = slice;
  const listings = getListingsById(state, currentPageResultIds);

  return {
    listings,
    queryInProgress,
    queryListingsError,
  };
};
